(() => {
  if (window.NubsForumClient) return;
  const script=document.currentScript || document.querySelector('[data-nubs-forum-warmup]');
  const bridge=String(script?.dataset.bridgeUrl || '').replace(/\/+$/,'');
  if (!bridge) return;
  const KEY='nubs-community-forum-public-v4';
  let inFlight=null;
  let generation=0;
  function read() {try{const value=JSON.parse(sessionStorage.getItem(KEY)||'null');return value&&Date.now()-value.savedAt<60000?value:null;}catch(_){return null;}}
  function index({force=false}={}) {
    const cached=!force&&read(); if(cached)return Promise.resolve({ok:true,...cached});
    if(inFlight)return inFlight;
    const epoch=generation;
    const job=fetch(`${bridge}/bridge/community-forum?mode=index`,{credentials:'omit',cache:'no-store',headers:{Accept:'application/json'}})
      .then(async response=>{const body=await response.json();if(!response.ok||!body.ok)throw new Error('Unable to load discussions.');if(epoch===generation){try{sessionStorage.setItem(KEY,JSON.stringify({savedAt:Date.now(),categories:body.categories,threads:body.threads,pageInfo:body.pageInfo}));}catch(_){}}return body;})
      .finally(()=>{if(inFlight===job)inFlight=null;});inFlight=job;return job;
  }
  function clear(){generation++;inFlight=null;try{sessionStorage.removeItem(KEY);}catch(_){}}
  window.NubsForumClient={index,clear};
  const warm=()=>{if(!navigator.connection?.saveData&&document.visibilityState!=='hidden')index().catch(()=>{});};
  let intent;
  document.addEventListener('pointerover',event=>{if(event.target.closest?.('a[href*="/pages/forum"]')){clearTimeout(intent);intent=setTimeout(warm,100);}});
  document.addEventListener('focusin',event=>{if(event.target.closest?.('a[href*="/pages/forum"]'))warm();});
  if(location.pathname.replace(/^\/(fr|es)(?=\/)/,'')==='/pages/forum')warm();
})();
